import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReportsAbstractService} from './reports-abstract.service';
import {Observable} from 'rxjs';

@Injectable()
export class RefundReportService extends ReportsAbstractService {
  public reportRoute: string = 'refund_report'
  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  getSummary(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/summary/", params);
  }

  getPathRefundsReport(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/path_refunds_report/", params);
  }

  getStepRefundsReport(params: any): Observable<any> {
    params['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    return this.http.post<any>(this.route + "/step_refunds_report/", params);
  }

  downloadFile(queryParams, elem) {
    queryParams['customer_mode'] = this.customerMode.getValue() ? 'true' : 'false';
    this.getDownloadReportData(queryParams)
      .subscribe(_ => {
        elem.loading = false
      }, error => {
        elem.loading = false
      })
  }
}
